module.exports = __webpack_public_path__ + "img/22_2.5ee7a8c6.png";